<template>
  <div class="small">
          <line-chart :height="300" :chart-data="CHARTDATA"></line-chart>
  </div>
</template>

<script>
  import LineChart from '@/plugins/LineChart.js'

  export default {
      components: {
        LineChart
      },
        data: () => ({
          labels: [],
          data:[],
          datacollection:{},
          gradient: null,
      }),
      props: {
        show:{
            type: Boolean,
            default: false
        },
        rawdata: {
          type: Array,
          default: function(){ return []}
        }
      },
    watch: {
      show(v) {
        if(v){
            this.exportData()
            this.fillData(this.data,this.labels)
        }
       
        
      }
    },
    computed: {
      CHARTDATA() {
        return this.datacollection
      },
      BGCOLOR() {
        var canvas = document.getElementById('line-chart')
         var gradient = canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
        gradient.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradient.addColorStop(1, "rgba(255, 255, 255, 0.24)");
        return gradient
      }
    },
    methods: {
      exportData() {
        this.labels = []
        this.data = []
       
        for (const item of this.rawdata) {
              this.labels.push(item.sales_date)
              this.data.push(item.amount)
          }
      
      },
      fillData (_data, _labels) {
        
        this.datacollection = {
          labels:_labels,
          datasets: [
            {
              label: this.$moment().format("MMMM") +  " Gross Sales",
              backgroundColor: this.BGCOLOR,
              borderColor: "#9B70FA",
              pointBorderColor: "#9B70FA",
              pointBackgroundColor: "#9B70FA",
              pointBorderWidth: 2,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 1,
              pointRadius: 4,
              borderWidth: 0.5,
              fill: true,
              data: _data
            }
          ]
        }
        // setTimeout(()=>{
        //   this.datacollection.datasets[0].backgroundColor = this.BGCOLOR
        //   console.log(this.datacollection.datasets[0].backgroundColor)
        // }, 1000)
        

      
      }
    }
  }
</script>

<style>
  .small {
    height: 300px;
  }
</style>